<template>
    <div class="agent-chat__launcher" :class="`agent-chat__launcher--${position}`">
        <div v-if="open" class="agent-chat__launcher-window">
            <slot></slot>
        </div>

        <button
            type="button"
            class="agent-chat__fab"
            :aria-label="open ? 'Chiudi chat' : 'Apri chat'"
            :aria-expanded="open ? 'true' : 'false'"
            @click="$emit('toggle')"
        >
            <span v-if="open">&times;</span>
            <span v-else>&#128172;</span>
        </button>
    </div>
</template>

<script>
export default {
    name: 'AgentChatLauncher',
    props: {
        open: {
            type: Boolean,
            default: false,
        },
        position: {
            type: String,
            default: 'bottom-right',
        },
    },
    emits: ['toggle'],
};
</script>

<style scoped>
.agent-chat__launcher {
    position: fixed;
    z-index: 1050;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 12px;
}

.agent-chat__launcher--bottom-right {
    right: 24px;
    bottom: 24px;
}

.agent-chat__launcher--bottom-left {
    left: 24px;
    bottom: 24px;
    align-items: flex-start;
}

.agent-chat__launcher-window {
    width: 380px;
    max-width: calc(100vw - 48px);
    height: 560px;
    max-height: calc(100vh - 120px);
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.22);
    overflow: hidden;
    display: flex;
}

.agent-chat__fab {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    border: none;
    background: #ea580c;
    color: #fff;
    font-size: 24px;
    line-height: 1;
    cursor: pointer;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
    align-self: flex-end;
}

.agent-chat__launcher--bottom-left .agent-chat__fab {
    align-self: flex-start;
}
</style>
